import __request__ from "routing/request";
export function list(page = 1, per_page = 50, query, sort = "name", order = "asc", requestOptions) {
  return __request__("GET", "/collectors/fleets", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONbody, requestOptions) {
  return __request__("POST", "/collectors/fleets", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkStats(requestOptions) {
  return __request__("GET", "/collectors/fleets/stats", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(fleetId, requestOptions) {
  return __request__("GET", `/collectors/fleets/${fleetId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(fleetId, JSONbody, requestOptions) {
  return __request__("PUT", `/collectors/fleets/${fleetId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(fleetId, requestOptions) {
  return __request__("DELETE", `/collectors/fleets/${fleetId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function stats(fleetId, requestOptions) {
  return __request__("GET", `/collectors/fleets/${fleetId}/stats`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
